import React from 'react'
import AboutOption from '../components/AboutOption'
import Gideon from '../images/perfect2.JPG'
import Seb from '../images/seb.JPG'
import Mo from '../images/Mo.JPG'
import FirstImage from '../images/groc.jpg'

function About() {
    return (
        <div className="About">
            <AboutOption
            image={FirstImage}
            heading="About the App"
            description="This app was made with love by the creators to make delivery 
            of groceries to residents of Abu Dhabi hassle free. We were inspired by the
            struggles we had to go through to get even common products due to our location
            in sadiyat island. We hope that residents will find this app useful. We'd appreciate
            any feedback because we are here to serve you."
            />
            <br />
            <hr />
            <AboutOption
            image={Gideon}
            heading="Meet the Creators"
            description="I am Gideon Akosah Agyemang Yeboah, a junior at NYUAD offering a major
            in computer Science with a minor in Math. I am a full stack developer with experience
            in JavaScript-and its frameworks, python-Django-, CSS and other tools used in web development.
            When I am not working on my computer, I am either watching YouTube or sleeping."
            />  
            <br />
            <hr />
            <AboutOption
            image={Seb}
            heading="Meet the Creators"
            description="Hello! I am Sebastiano Pio Matera from Italy, Spain, and the Philippines.
            I am majoring in Computer Science with a minor in Economics. I have experience with full
            stack development and data science. I have experience working with Python, JavaScript, C/C++, SQL, and front-end
            programming languages. I love playing football and competing in triathlons"
            />  
            <br />
            <hr />
            <AboutOption
            image={Mo}
            heading="Meet the Creators"
            description="Hello! I am Mohammed Arham from Bangladesh, majoring in Computer Science. I have some 
            experience working with JavaScript, PHP, SQL. I prefer working with databases and the backend. My hobbies include
            playing video games and watching Netflix( currently on arrested development haha)"
            />  
            <br />
            
        </div>
    )
}

export default About
